import { addPvNew, getUrlParams, isBaiduMap, isBaiduMapAuto, isHarmony } from '../../../utils';
import { goThirdApp } from '../utils';
import { usePushComponent } from '../pushConfig';
import { showFeedBury } from '../bury';
import { isScreenOptimization } from '../abtestConfig.js';
export default {
  components: {},
  props: {
    author: {
      type: Object,
      default() {
        return {};
      }
    },
    guide: {
      type: Object,
      default() {
        return {};
      }
    },
    // 埋点参数
    unique_id: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    cityId: {
      type: Number,
      default: 131
    },
    index: {
      type: Number,
      default: 0
    },
    dataType: {
      type: String,
      default: 'feed'
    },
    date: {
      type: String,
      default: ''
    },
    noteType: {
      type: String,
      default: 'image'
    },
    poiLink: {
      type: String,
      default: ''
    }
  },
  data() {
    const params = getUrlParams(location.href);
    const {
      abtest = '',
      pushfrom = '',
      topic = '',
      origin_from = ''
    } = params || {};
    return {
      avator: '',
      nickName: '',
      thirdIcon: '',
      thirdText: '',
      moreInfo: '',
      tpSource: '',
      tpShowSource: '',
      contentSource: '',
      // 是否是权威账号
      isQwzh: 0,
      isBaiduMap: isBaiduMap(),
      abtest: abtest || '',
      pushfrom: pushfrom,
      isBaiduMapAuto: isBaiduMapAuto(),
      // 车机地图
      topic: topic,
      origin_from: origin_from,
      vIconLogo: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/v-icon-logo.png',
      isScreenOptimization
    };
  },
  computed: {
    // 是否展示跳转第三方更多
    showMoreTag() {
      return this.poiLink && !this.isBaiduMapAuto && this.isBaiduMap && this.guide.message && !isHarmony();
    }
  },
  async mounted() {
    const {
      avator = '',
      name = '',
      provider = {},
      contentSource = '',
      isQwzh,
      tpSource: tpShowSource = '' // 页面展示埋点使用author下的tpSource字段
    } = this.author || {};
    this.tpShowSource = tpShowSource;
    this.avator = avator || 'https://himg.bdimg.com/sys/portrait/item/f35c103e?r=1566888856';
    this.nickName = name;
    const {
      icon = '',
      text = ''
    } = provider;
    this.thirdIcon = icon;
    this.thirdText = text;
    const {
      tpSource = ''
    } = this.guide || {};
    this.isQwzh = Number(isQwzh) || 0;
    // 埋点参数
    this.tpSource = tpSource;
    this.contentSource = contentSource;
    // 首篇笔记一定会曝光，排除首篇是push的场景
    if (this.index === 0 && !usePushComponent(this.tpShowSource, this.source)) {
      showFeedBury(this.index);
    }
    this.showHandle();
  },
  methods: {
    // 点击头像跳转到用户主页
    goHomePage() {
      // 鸿蒙系统禁止跳转
      if (isHarmony()) {
        return;
      }
      // 车机地图禁止跳转
      if (this.isBaiduMapAuto) {
        return;
      }
      if (!this.isBaiduMap) {
        this.$emit('open-Baidu-Map');
        return;
      }
      if (this.dataType === 'comment') {
        addPvNew(['POl.comment_list.head.click'], {
          tp_from: this.tpShowSource || this.tpSource
        });
        this.commentHeadClick();
        return;
      }
      if (this.poiLink) {
        this.poiThirdApp();
        return;
      }
      const url = this.author.detailUrl || '';
      if (!url) {
        return;
      }
      // 埋点
      addPvNew(['NewMedia.detailspagetouxiang.click'], {
        source: this.source
      });
      const {
        directJump = false,
        fallbackUrl = ''
      } = this.author || {};
      let jumpParam = {};
      // 是否直接跳转其他app
      if (directJump) {
        jumpParam = {
          scheme: url,
          fallbackUrl,
          pvHead: ['NewMedia.detailspage.callup.success.click'],
          pvParam: {
            city_id: this.cityId
          }
        };
      }
      goThirdApp({
        jumpParam,
        directJump,
        detailUrl: url,
        fallbackUrl,
        feedType: this.dataType
      });
    },
    poiThirdApp() {
      const {
        tpSource = '',
        more: {
          detailUrl = '',
          fallbackUrl = '',
          directJump = false
        } = {}
      } = this.guide || {};
      // 是否直接跳转其他app
      let jumpParam = {};
      if (directJump) {
        jumpParam = {
          scheme: detailUrl,
          fallbackUrl,
          pvHead: ['NewMedia.detailspage.callup.success.click'],
          // 跳转成功埋点
          pvParam: {
            type: tpSource,
            callup_type: 1
          },
          // 跳转失败埋点
          failPvParam: {
            type: tpSource,
            callup_type: 2
          },
          isAddSuccAndFail: true
        };
      }
      goThirdApp({
        jumpParam,
        directJump,
        detailUrl,
        fallbackUrl,
        feedType: this.dataType
      });
    },
    // 评论转笔记点击更多跳转到app
    commentHeadClick() {
      const {
        detail_url: detailUrl = '',
        fallback_url: fallbackUrl = ''
      } = this.guide || {};
      // 评论转笔记用户头像点击：百度用户无反应，tp用户跳到小程序评论列表
      if (!detailUrl) {
        return;
      }
      const jumpParam = {
        scheme: detailUrl,
        fallbackUrl,
        pvHead: ['NewMedia.detailspage.callup.success.click'],
        isAddSuccAndFail: true
      };
      goThirdApp({
        jumpParam,
        directJump: true,
        detailUrl,
        fallbackUrl,
        feedType: this.dataType
      });
    },
    showHandle() {
      if (this.dataType !== 'comment') {
        return;
      }
      this.$nextTick(() => {
        const commentRef = this.$refs.microFeedTitle;
        commentRef && this.$io.observe(commentRef, () => {
          addPvNew(['POl.comment_list.head.show'], {
            tp_from: this.tpShowSource || this.tpSource
          });
        });
      });
    }
  }
};